(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["top-bar"] && !Shopify.designMode) return;
  try {
    
  let top_bar = document.querySelector('.section-top-bar')?.clientHeight || 0;
  const body = document.querySelector('body');
  body.style.setProperty('--height-topbar', `${top_bar}px`);

  function updateTopbarSlidesWidth() {
    const sliders = document.querySelectorAll('#topbar .text-slide slide-section');
    sliders.forEach((slider) => {
      const slideTexts = slider.querySelectorAll('.swiper-slide > div');
      if (!slideTexts.length) return;

      let maxWidth = 0;
      slideTexts.forEach((node) => {
        maxWidth = Math.max(maxWidth, Math.ceil(node.scrollWidth));
      });

      const sliderItem = slider.closest('.text-slide');
      const availableWidth = Math.floor(sliderItem?.clientWidth || slider.parentElement?.clientWidth || maxWidth);
      const finalWidth = Math.min(maxWidth, Math.max(0, availableWidth));
      slider.style.setProperty('--topbar-max-slide-width', `${finalWidth}px`);
    });
  }

  updateTopbarSlidesWidth();
  window.addEventListener('load', updateTopbarSlidesWidth);
  setTimeout(updateTopbarSlidesWidth, 250);
  window.addEventListener('resize', updateTopbarSlidesWidth);

  // Marquee su mobile: scorre il testo se tronco, poi avanza dopo 3s
  (function () {
    if (window.innerWidth >= 1025) return;

    const MARQUEE_SPEED = 50; // px al secondo
    const HOLD_MS = 3000;     // ms di attesa dopo il marquee (o se testo corto)
    const START_DELAY_MS = 2000; // ms di pausa prima che inizi il marquee
    let tid = null;

    function resetTextEl(el) {
      el.classList.remove('topbar-marquee-active');
      el.style.removeProperty('--marquee-dist');
      el.style.removeProperty('animation-duration');
      void el.offsetWidth; // force reflow per resettare l'animazione
    }

    function runSlide(swiper) {
      if (tid) clearTimeout(tid);

      const activeSlide = swiper.slides[swiper.activeIndex];
      if (!activeSlide) return;

      const textEl = activeSlide.querySelector('div');
      if (!textEl) {
        tid = setTimeout(function () {
          swiper.slideNext();
          setTimeout(function () { runSlide(swiper); }, 50);
        }, HOLD_MS);
        return;
      }

      resetTextEl(textEl);

      const overflow = textEl.scrollWidth - textEl.offsetWidth;

      if (overflow > 5) {
        const durS = Math.round((overflow / MARQUEE_SPEED) * 100) / 100;

        tid = setTimeout(function () {
          textEl.style.setProperty('--marquee-dist', '-' + overflow + 'px');
          textEl.style.setProperty('animation-duration', durS + 's');
          textEl.classList.add('topbar-marquee-active');

          tid = setTimeout(function () {
            resetTextEl(textEl);
            swiper.slideNext();
            setTimeout(function () { runSlide(swiper); }, 50);
          }, durS * 1000 + HOLD_MS);
        }, START_DELAY_MS);
      } else {
        tid = setTimeout(function () {
          swiper.slideNext();
          setTimeout(function () { runSlide(swiper); }, 50);
        }, HOLD_MS);
      }
    }

    function setup() {
      const slideEl = document.querySelector('#topbar .text-slide slide-section');
      if (!slideEl || !slideEl.swiper) {
        setTimeout(setup, 300);
        return;
      }
      const swiper = slideEl.swiper;
      swiper.autoplay.stop();
      runSlide(swiper);
    }

    setTimeout(setup, 600);
    window.addEventListener('load', function () { setTimeout(setup, 400); });
  })();

  } catch(e) { console.error(e); }
})();
})();
